import {
  PaymentMethodFieldsGroup,
  emptyPaymentMethodDraft,
  loanDraftToPaymentDraft,
  paymentDraftToLoanDraft,
} from "@/components/sales/PaymentMethodFields";
import type { BankOption } from "@/lib/sales/banksStore";

export type LoanPaymentDraft = {
  paymentMethod: string;
  bankId: string;
  referenceNo: string;
  chequeNo: string;
  chequeDate: string;
};

export const emptyLoanPaymentDraft = (): LoanPaymentDraft => ({
  paymentMethod: "",
  bankId: "",
  referenceNo: "",
  chequeNo: "",
  chequeDate: "",
});

export function LoanPaymentMethodFields({
  value,
  onChange,
  banks,
  compact = false,
  stacked = true,
  label = "Payment method",
  groupClassName,
  detailClassName,
}: {
  value: LoanPaymentDraft;
  onChange: (patch: Partial<LoanPaymentDraft>) => void;
  banks: BankOption[];
  compact?: boolean;
  /** Stack method, bank, and reference fields one per row. */
  stacked?: boolean;
  label?: string;
  groupClassName?: string;
  detailClassName?: string;
}) {
  const draft = loanDraftToPaymentDraft(value);

  // One gap only — do not combine space-y-* with stacked gap-* (that doubles Method→Bank).
  const resolvedGroupClass = groupClassName ?? "w-full min-w-0";
  const resolvedDetailClass = detailClassName ?? "grid grid-cols-1 gap-4 w-full min-w-0";

  return (
    <PaymentMethodFieldsGroup
      value={draft}
      onChange={(next) => onChange(paymentDraftToLoanDraft(next))}
      banks={banks}
      compact={compact}
      stacked={stacked}
      methodWithBankRow={false}
      allowNone={false}
      required={!compact}
      label={label}
      labelClassName={compact ? "text-xs text-muted-foreground" : "text-xs font-bold text-foreground"}
      inputClassName="glass-input h-10 w-full"
      triggerClassName="glass-input h-10 w-full"
      selectClassName="w-full"
      className={resolvedGroupClass}
      detailClassName={resolvedDetailClass}
    />
  );
}
